import { render, staticRenderFns } from "./SEOControl.vue?vue&type=template&id=429e183e&"
import script from "./SEOControl.vue?vue&type=script&lang=js&"
export * from "./SEOControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports